/* eslint-disable */
import { useEffect, useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { assetImages } from "constants";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import { eventslug } from "Config/Config";
import { getFormatedDateInString } from "helper/EventHelper/EventHelper";

const Banner = () => {
  const todayValue = new Date().toISOString().split("T")[0];

  const [eventTitle, seteventTitle] = useState("");
  const [eventSummary, seteventSummary] = useState("");
  const [eventDetails, seteventDetails] = useState("");
  const [location, setlocation] = useState("");
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [startTime, setstartTime] = useState("");
  const [endTime, setendTime] = useState("");

  // console.log(eventDetails);
  //function for get event details
  const getEventDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_EVENT_DETAILS_BY_SLUG +
        `?eventslug=${eventslug}`;

      console.log("url of event details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of event details------>", response);

      if (response.status) {
        localStorage.setItem("eventId", response.data._id);

        seteventTitle(response?.data?.title);
        seteventSummary(response?.data?.summary);
        seteventDetails(response?.data?.description);
        //assign zipcode
        setzipcode(response?.data?.zipcode);

        //assign city
        setcityName(response?.data?.city);

        //assign state
        setstateName(response?.data?.state);

        //assign country
        setcountry(response?.data?.country);

        //assign location
        setlocation(response?.data?.address);

        //assign start date
        setstartDate(response?.data?.fromdate);

        //assign start time
        setstartTime(response?.data?.starttime);

        //assign end date
        setendDate(response?.data?.todate);

        //assign end time
        setendTime(response?.data?.endtime);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // const assignEventData = () => {
  //   seteventTitle(storedEventDetails.title);
  //   seteventSummary(storedEventDetails.summary);
  //   seteventDetails(storedEventDetails.description);
  //   //assign zipcode
  //   setzipcode(storedEventDetails.zipcode);

  //   //assign city
  //   setcityName(storedEventDetails.city);

  //   //assign state
  //   setstateName(storedEventDetails.state);

  //   //assign country
  //   setcountry(storedEventDetails.country);

  //   //assign location
  //   setlocation(storedEventDetails.address);

  //   //assign start date
  //   setstartDate(storedEventDetails.fromdate);

  //   //assign start time
  //   setstartTime(storedEventDetails.starttime);

  //   //assign end date
  //   setendDate(storedEventDetails.todate);

  //   //assign end time
  //   setendTime(storedEventDetails.endtime);
  // };

  useEffect(() => {
    getEventDetails();
  }, []);

  return (
    <section
      className="banner_sec"
      style={{ backgroundImage: `url(${assetImages.homeBannerImg})` }}
    >
      <div className="banner_content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="banner_leftpnl">
                <h1 className="text-white text-uppercase mb-3">{eventTitle}</h1>
                <div className="bnr_info">
                  <ul className="list_style_none">
                    <li className="d-flex align-items-center gap-1 text-white fs-md fw-bold mb-2">
                      <i className="material-icons-outlined fs-md">
                        {" "}
                        calendar_month
                      </i>
                      <span>
                        {startDate != ""
                          ? getFormatedDateInString(startDate)
                          : ""}{" "}
                        -{" "}
                        {endDate != "" ? getFormatedDateInString(endDate) : ""}
                      </span>
                    </li>
                    <li className="d-flex align-items-center gap-1 text-white fs-md fw-bold mb-2">
                      <i className="material-icons-outlined fs-md"> place</i>
                      <span>
                        {cityName}
                        {stateName == "" ? "" : ","} {stateName}
                        {country == "" ? "" : ", -"}
                        {country}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="bnr_gredient_btns d-flex align-items-center gap-2 mt-4 mb-4">
                  <Link to="#" className="btn primary-btn">
                    ENTRAR EVENTO
                  </Link>
                  <Link to="#" className="btn primary-btn">
                    REGISTRO GRATUITO
                  </Link>
                </div>
                <div className="event_time py-3 px-4 bg_white d-inline-block">
                  <h5 className="fs-sm text-uppercase text-primary mb-1">
                    {startDate > todayValue
                      ? "Scheduled to start"
                      : startDate < todayValue
                      ? "Commenced from"
                      : "Join events"}
                  </h5>
                  <h4 className="text-uppercase text-primary fs-lg fw-bold">
                    {startDate > todayValue
                      ? `${getFormatedDateInString(startDate)} ${startTime}`
                      : startDate < todayValue
                      ? `${getFormatedDateInString(startDate)} ${startTime}`
                      : `Today at ${startTime}`}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="banner_rightpnl">
                <h2 className="text-uppercase mb-4 text-white">
                  {/* EL FORO QUE REUNE AL <br /> ECOSISTEMA STARTUP MUNDIAL */}
                  {eventSummary.slice(0, 50)}
                </h2>
                <p
                  className="text-white fs-md"
                  dangerouslySetInnerHTML={{ __html: eventDetails }}
                ></p>
                <div className="bnr_gredient_btns d-flex align-items-center gap-2 mt-4">
                  <Link to="/agenda" className="btn primary-btn">
                    VIEW AGENDA
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
